<form [formGroup]="form" class="style-form">
    <!-- <div class="style-input-default" data-text="Accion autorizada *" [ngClass]="{error: verificateInput('nombre_empresa')}"> -->
      <!-- <input type="text" placeholder="Accion autorizada" formControlName="accion_autorizada"> -->
     
     <!-- <div class="divSelector">
         <p class="inputRadio">Sellos</p>
        <mat-radio-group class="checleft" formControlName="sellos" aria-label="Select an option">
            <mat-radio-button value="Si">Si</mat-radio-button>
            <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
          </mat-radio-group>
     </div>
     <div class="divSelector">
        <p class="inputRadio">Firmas del Titular</p>
       <mat-radio-group class="checleft" formControlName="firma" aria-label="Select an option">
           <mat-radio-button value="Si">Si</mat-radio-button>
           <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
         </mat-radio-group>
    </div>
    <div class="divSelector">
        <p class="inputRadio">Telefonos</p>
       <mat-radio-group class="checleft" formControlName="telefonos" aria-label="Select an option">
           <mat-radio-button value="Si">Si</mat-radio-button>
           <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
         </mat-radio-group>
    </div>
    <div class="divSelector">
        <p class="inputRadio">Número de Cuenta</p>
       <mat-radio-group class="checleft" formControlName="cuenta" aria-label="Select an option">
           <mat-radio-button value="Si">Si</mat-radio-button>
           <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
         </mat-radio-group>
    </div>
    <div class="divSelector">
        <p class="inputRadio">Contenido del Correo de la Solicitud</p>
       <mat-radio-group class="checleft" formControlName="contenidoCorreo" aria-label="Select an option">
           <mat-radio-button value="Si">Si</mat-radio-button>
           <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
         </mat-radio-group>
    </div>
    <div class="divSelector">
        <p class="inputRadio">Monto/Saldo Disponible</p>
       <mat-radio-group class="checleft" formControlName="monto" aria-label="Select an option">
           <mat-radio-button value="Si">Si</mat-radio-button>
           <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
         </mat-radio-group>
    </div> -->
    <div class="flex">
      <div class="opcionCheck ">
        <p class="texto">Sellos</p>
        <mat-checkbox formControlName="sellos" ></mat-checkbox>
      </div>
      <div class="opcionCheck ">
        <p class="texto">Firmas del Titular</p>
        <mat-checkbox formControlName="firma" ></mat-checkbox>
      </div>
     </div>
    <div class="flex">
      <div class="opcionCheck ">
        <p class="texto">Teléfonos</p>
        <mat-checkbox formControlName="telefonos" ></mat-checkbox>
      </div>
      <div class="opcionCheck ">
        <p class="texto">Número de Cuenta</p>
        <mat-checkbox formControlName="cuenta" ></mat-checkbox>
      </div>
     </div>
    <div class="flex">
      <div class="opcionCheck ">
        <p class="texto">Contenido del Correo de la Solicitud</p>
        <mat-checkbox formControlName="contenidoCorreo" ></mat-checkbox>
      </div>
      <div class="opcionCheck ">
        <p class="texto">Monto/Saldo Disponible</p>
        <mat-checkbox formControlName="monto" ></mat-checkbox>
      </div>
     </div>
</form>
